// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AdminShopListPage from "./AdminShopListPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as AdminImpersonationPage from "./AdminImpersonationPage.res.js";

function AdminRouter(props) {
  let subUrlPath = props.subUrlPath;
  if (subUrlPath !== 0) {
    switch (subUrlPath.hd) {
      case "impersonation" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(AdminImpersonationPage.make, {});
        }
        break;
      case "shops" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(AdminShopListPage.make, {});
        }
        break;
    }
  }
  return JsxRuntime.jsx(Navigation.Redirect.make, {
    route: props.appIndexRoute
  });
}

let make = React.memo(AdminRouter);

export {
  make,
}
/* make Not a pure module */
